export const GET_VERIFICATION_REQUESTS = "GET_VERIFICATION_REQUESTS";
export const UPDATE_VERIFICATION_STATUS = "UPDATE_VERIFICATION_STATUS";
export const DELETE_VERIFICATION_REQUEST = "DELETE_VERIFICATION_REQUEST";
